<ng-container *transloco="let t; read: 'partials.ui.form_control'">
  <div [ngClass]="{ checkbox: type === 'checkbox', radiogroup: type === 'radiogroup', inline: inline === true, 'p-field-acr p-mb-4': noMargin === false }">
    <label *ngIf="type !== 'checkbox' && type !== 'radiogroup' && showLabel === true" for="input_{{ cid }}" id="label_{{ cid }}"
      >{{ label
      }}<span class="required-mark" [ngClass]="{visible: edit === true && isRequired() && label !== null && label !== ''}" pTooltip="{{ t('required') }}" aria-label="{{ t('required') }}"
        >*</span
      ><span *ngIf="info"><i class="pi pi-info-circle" [pTooltip]="info"></i></span></label
    >
    <div class="p-inputgroup" *ngIf="edit !== true">
      <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'checkbox'">
          <div style="width: 30px !important">
            <div class="checkbox-value">
              <i *ngIf="basevalue === true" class="pi pi-check"></i>
              <i *ngIf="basevalue !== true" class="pi pi-ban"></i>
            </div>
          </div>
          <label for="input_{{ cid }}" id="label_{{ cid }}">{{ label }}</label>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div *ngIf="basevalue === null || basevalue === ''" aria-labelledby="label_{{ cid }}">-</div>
          <div *ngIf="basevalue !== null && basevalue !== '' && type !== 'textarea'" aria-labelledby="label_{{ cid }}">{{ basevalue }}</div>
          <div *ngIf="basevalue !== null && basevalue !== '' && type === 'textarea'" [innerHTML]="basevalue | nl2br" aria-labelledby="label_{{ cid }}"></div>
        </ng-container>
      </ng-container>
    </div>
    <div class="p-inputgroup" *ngIf="edit === true" [ngSwitch]="type">
      <ng-container *ngSwitchCase="'checkbox'">
        <div style="width: 30px !important">
          <p-checkbox #field [formControl]="control" id="input_{{ cid }}" binary="true" aria-labelledby="label_{{ cid }}"></p-checkbox>
        </div>
        <label for="input_{{ cid }}" id="label_{{ cid }}">{{ label }}</label>
      </ng-container>
      <div *ngSwitchCase="'input'">
        <input #field [formControl]="control" id="input_{{ cid }}" type="text" pInputText [placeholder]="placeholder" aria-labelledby="label_{{ cid }}" [placeholder]="showPlaceholder ? placeholder : ''" />
      </div>
      <div *ngSwitchCase="'password'">
        <input #field [formControl]="control" id="input_{{ cid }}" type="password" pPassword autocomplete="new-password" [feedback]="false" aria-labelledby="label_{{ cid }}" />
      </div>
      <div *ngSwitchCase="'textarea'">
        <textarea
          #field
          [formControl]="control"
          id="input_{{ cid }}"
          [rows]="controlConfig.rows"
          pInputTextarea
          [autoResize]="controlConfig.autoResize"
          aria-labelledby="label_{{ cid }}"
        ></textarea>
      </div>
      <div *ngSwitchCase="'select'">
        <p-dropdown
          [formControl]="control"
          id="input_{{ cid }}"
          [options]="options"
          [editable]="editable"
          [optionLabel]="optionLabel"
          [dataKey]="dataKey"
          [placeholder]="(showPlaceholder) ? t('please_select') : ''"
          [autoDisplayFirst]="false"
          [filter]="filter"
          [resetFilterOnHide]="filter"
          [showClear]="showClear"
          appendTo="body"
          aria-labelledby="label_{{ cid }}"
          (onChange)="onSelect()"
        ></p-dropdown>
      </div>
      <div *ngSwitchCase="'cascade'">
        <p-cascadeSelect
          [formControl]="control"
          id="input_{{ cid }}"
          [options]="options"
          [optionLabel]="optionLabel"
          [dataKey]="dataKey"
          [optionGroupLabel]="optionGroupLabel"
          [optionGroupChildren]="optionGroupChildren"
          [placeholder]="(showPlaceholder) ? t('please_select') : ''"
          aria-labelledby="label_{{ cid }}"
        ></p-cascadeSelect>
      </div>
      <div *ngSwitchCase="'group'">
        <p-dropdown
          [formControl]="control"
          id="input_{{ cid }}"
          [options]="options"
          [placeholder]="(showPlaceholder) ? t('please_select') : ''"
          [autoDisplayFirst]="false"
          [group]="true"
          aria-labelledby="label_{{ cid }}"
          [filter]="true"
          [filterBy]="filterBy"
          [autofocusFilter]="true"
          [resetFilterOnHide]="true"
          [showClear]="true"
          appendTo="body"
          [emptyFilterMessage]="t('no_filter_results')"
        ></p-dropdown>
      </div>
      <div *ngSwitchCase="'multiselect'">
        <p-multiSelect
          [formControl]="control"
          id="input_{{ cid }}"
          [options]="options"
          [optionLabel]="optionLabel"
          [dataKey]="dataKey"
          [filter]="true"
          [group]="group"
          [resetFilterOnHide]="true"
          aria-labelledby="label_{{ cid }}"
          [selectedItemsLabel]="t('all_selected')"
          [showClear]="showClear"
          [maxSelectedLabels]="(showAllSelected === true) ? options.length - 1 : 100000"
        ></p-multiSelect>
      </div>
      <div *ngSwitchCase="'date'">
        <p-calendar
          [formControl]="control"
          id="input_{{ cid }}"
          [showTime]="showTime"
          hourFormat="24"
          dateFormat="dd.mm.yy"
          [minDate]="minDate"
          [maxDate]="maxDate"
          aria-labelledby="label_{{ cid }}"
          aria-describedby="aria_date"
          [placeholder]="(showTime === true) ? 'dd.mm.yyyy hh:mm' : 'dd.mm.yyyy'"
          [attr.aria-placeholder]="(showTime === true) ? 'dd.mm.yyyy hh:mm' : 'dd.mm.yyyy'"
          [firstDayOfWeek]="firstDayOfWeek"
          appendTo="body"
          (onSelect)="onSelect()"
          (onInput)="onSelect()"
        ></p-calendar>
      </div>
      <div *ngSwitchCase="'date-month'">
        <p-calendar
          [formControl]="control"
          id="input_{{ cid }}"
          dateFormat="mm.yy"
          [minDate]="minDate"
          [maxDate]="maxDate"
          aria-labelledby="label_{{ cid }}"
          aria-describedby="aria_date"
          placeholder="mm.yyyy"
          aria-placeholder="mm.yyyy"
          view="month"
          appendTo="body"
          (onSelect)="onSelect()"
          (onInput)="onSelect()"
        ></p-calendar>
      </div>
      <div *ngSwitchCase="'time'">
        <p-calendar
          [formControl]="control"
          id="input_{{ cid }}"
          showTime="true"
          hourFormat="24"
          [timeOnly]="true"
          [readonlyInput]="readonlyInput"
          (onSelect)="onSelect()"
          aria-labelledby="label_{{ cid }}"
          placeholder="hh:mm"
          aria-placeholder="hh:mm"
          [firstDayOfWeek]="firstDayOfWeek"
          appendTo="body"
          (onSelect)="onSelect()"
          (onInput)="onSelect()"
        ></p-calendar>
      </div>
      <div *ngSwitchCase="'chips'">
        <p-chips
          [formControl]="control"
          id="input_{{ cid }}"
          aria-labelledby="label_{{ cid }}"
          separator=","
        ></p-chips>
      </div>
      <div *ngSwitchCase="'radiogroup'">
        <ng-container *ngFor="let option of options">
          <p-radioButton name="group_{{ cid }}" [value]="option.value" [label]="option.label" [formControl]="control"></p-radioButton><br>
        </ng-container>
      </div>
      <div *ngSwitchCase="'slider'" class="p-grid">
        <div class="p-col p-pt-3">
          <p-slider [formControl]="control" id="input_{{ cid }}" [min]="min" [max]="max" [step]="step" aria-labelledby="label_{{ cid }}"></p-slider>
        </div>
        <div class="p-col-fixed p-text-right" style="width: 20px">
          {{ control.value }}
        </div>
      </div>
      <app-form-error [control]="control" [label]="label"></app-form-error>
    </div>
  </div>

  <div class="p-d-none">
    <span id="aria_date"> {{ t("please_insert_date") }}</span>
  </div>
</ng-container>
